import { crudRequest } from '@/services/api';
import { dateDiffCalculation } from '@/utils/date';
import { message } from 'antd';
import moment from 'moment';
import BaseTable from '../baseTable';

const params = {
  // orderKey: 'waybillNo',
  // orderValue: '300478151658',

  // startDate: moment(new Date()).add(-2, 'month').format('YYYY-MM-DD 23:59:59'),
  // endDate: moment(new Date()).format('YYYY-MM-DD HH:mm:ss'),

  numberNo: '',
};
export default {
  namespace: 'centerroutetrajectory',
  state: {
    searchParams: { ...params },
    dataList: [],// 0实际,1计划,2最优,3重算
    briefingMsg: ''
  },

  effects: {
    *getDatas(_, { put, select }) {
      const { searchParams: { numberNo } } = yield select(({ centerroutetrajectory }) => centerroutetrajectory);
      const dataList = []
      const noLen = numberNo.length
      if (!noLen || (noLen !== 12 && noLen !== 20)) {
        return message.warning("运单号长度为12位，子单号长度为20位，请输入正确单号！")
      }
      crudRequest('/api/route/centerRouteTrajectory/search')
      for (let i = 0; i < BaseTable.length; i++) {
        const tableItem = BaseTable[i];
        const param = { tableName: tableItem.tableName, namespace: 'route_rs' }
        let apiUrl = ''
        if (noLen === 12) {
          apiUrl = '/api/route/hbase/queryByWayPrefix'
          param.waybillNo = numberNo
        } else if (noLen === 20) {
          apiUrl = '/api/route/hbase/queryBySubPrefix'
          param.subBillNo = numberNo
        }
        if (tableItem.tableNane === '重算') {
          apiUrl = '/api/forecastpath/queryLatestVersion'
        }
        const result = yield crudRequest(apiUrl, param)
        let data = result?.data?.map((m, i) => ({ ...m, key: i })) || []
        if (tableItem.tableNane === '计划') {
          data = data.filter(m => m.version === 1)
        }
        // else if (tableItem.tableNane === '重算') {
        //   data = data.filter(m => m.version === 9)
        // }
        dataList.push(data)
      }
      yield put({ type: 'updateState', payload: { dataList } })
    },
    // * getBriefing(_, { put, select }) {
    //   const { dataList } = yield select(({ centerroutetrajectory }) => centerroutetrajectory);

    //   const alur = dataList[0] //   实际
    //   const plan = dataList[2] //   最优
    //   const planSignTime = plan.find(m => m.scanType === '签收')?.scanTime || 0 // 预计签收时间

    //   const alurfirstData = alur[0]  // 实际数据第一条数据--录单
    //   const alurlastData = alur[alur.length - 1]  // 实际数据最新信息
    //   let briefingMsg = `运单当前在${alurlastData.scanSite}，` // 简报
    //   let WarehousTime = ''
    //   let allRunTime = '全程在途'
    //   let planSign = `预计签收时间${planSignTime},`
    //   let delayTime = '延误时长'

    //   let endTime = new Date()
    //   if (alurlastData.scanType === '签收') {
    //     briefingMsg = `运单已被签收！`
    //     endTime = alurlastData.scanTime
    //   } else if (alurlastData.scanType === '分拨装车' || alurlastData.scanType === '分拨发车') {
    //     WarehousTime = '入库时长'
    //   } else if (alurlastData.scanType === '分拨卸车' || alurlastData.scanType === '分拨到车') {
    //     WarehousTime = '已发车'
    //   }

    //   WarehousTime = WarehousTime && `${WarehousTime}${dateDiffCalculation(endTime, alurlastData.scanTime).formatDate}，`
    //   allRunTime = `${allRunTime}${dateDiffCalculation(endTime, alurfirstData.scanTime).formatDate}，`
    //   delayTime = `${delayTime}${dateDiffCalculation(alurlastData.scanTime, planSignTime).formatDate}`
    //   briefingMsg = `${briefingMsg}${WarehousTime}${allRunTime}${planSign}${delayTime}`

    //   const briefingMsgObj = {
    //     alurlastData,
    //     WarehousTime,
    //     allRunTime,
    //     delayTime,
    //     briefingMsg
    //   }
    //   yield put({ type: 'updateState', payload: { briefingMsg, briefingMsgObj } })
    // },
  },

  reducers: {
    updateState(state, { payload }) {
      return { ...state, ...payload };
    },
    searchParamsUpdate(state, { payload }) {
      const searchParams = { ...state.searchParams, ...payload };
      return { ...state, searchParams };
    },
    resetSearchParam(state) {
      return { ...state, searchParams: { ...params } };
    },
  },
};
